import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';

export interface PortalStatus {
  id: number;
  candidateId: number;
  candidateStatus: string;
  tfnStatus: string;
  trainingStatus: string;
  candidateProfile: string;
  superAnnuationStatus: string;
  astuteBankStatus: string;
  deductionStatus: string;
}

interface PortalStatusResponse {
  extraParam: Record<string, any>;
  isSuccess: boolean;
  message: string;
  data: PortalStatus | null;
}

@Injectable({
  providedIn: 'root',
})
export class PortalStatusService {
  private statusSubject = new BehaviorSubject<PortalStatus | null>(null);
  public status$ = this.statusSubject.asObservable();

  constructor(private http: HttpClient) {}

  refresh(): Observable<PortalStatusResponse> {
    const url = `${environment.apiConfig.uri}/Candidate/CandidateStatus`;
    return this.http.post<PortalStatusResponse>(url, {}).pipe(
      tap((response) => {
        if (response.data) {
          this.statusSubject.next(response.data);
          localStorage.setItem('bankdetailsStatus', response.data.astuteBankStatus || '');
          localStorage.setItem('superannuationStatus', response.data.superAnnuationStatus || '');
          localStorage.setItem('taxStatus', response.data.tfnStatus || '');
        }
      })
    );
  }

  get current(): PortalStatus | null {
    return this.statusSubject.getValue();
  }
}
